import React from "react";
import { useTranslation } from "react-i18next";
import Button from "../ui/Button";
import Icon from "../ui/Icon";

// Bloc « facture nominative » de l'écran 1d : proposition d'ajouter ses
// coordonnées, coordonnées enregistrées, ou échec d'enregistrement.
export default function InvoiceStatusBlock({ status, details, onAdd }) {
  const { t } = useTranslation();

  if (status === "saved" || status === "pending") {
    return (
      <div className="mt-4 rounded-2xl bg-qv-green-50 p-4 flex gap-3 items-start" role="status">
        <Icon name="check-circle-bold" size={22} className="text-qv-green" />
        <div className="min-w-0">
          <p className="text-sm leading-5 font-bold text-qv-green-900">{t("invoice.saved")}</p>
          {details && (
            <p className="mt-0.5 text-[13px] leading-[19px] font-medium text-qv-muted break-words">
              {t("invoice.savedDetail", {
                name: `${details.firstName} ${details.lastName}`,
                address: details.label || `${details.street}, ${details.postalCode} ${details.city}`,
              })}
            </p>
          )}
        </div>
      </div>
    );
  }

  if (status === "error") {
    return (
      <div className="mt-4 rounded-2xl bg-qv-red-50 p-4 flex flex-wrap gap-3 items-center" role="alert">
        <Icon name="danger-circle-linear" size={22} className="text-qv-red" />
        <p className="flex-1 text-sm leading-5 font-medium text-qv-red">{t("invoice.saveError")}</p>
        <button
          type="button"
          onClick={onAdd}
          className="h-10 rounded-lg border-[1.5px] border-qv-red bg-white px-3.5 text-sm font-semibold text-qv-red hover:bg-qv-red-50"
        >
          {t("invoice.retry")}
        </button>
      </div>
    );
  }

  return (
    <div className="mt-4 flex flex-col gap-2 md:flex-row md:items-center md:gap-4 md:rounded-2xl md:border md:border-qv-line md:p-4">
      <p className="text-center text-[13px] leading-[19px] font-medium text-qv-muted md:flex-1 md:text-left md:text-sm md:leading-5">
        {t("invoice.needInvoice")}
      </p>
      <Button
        variant="secondary"
        icon="document-add-linear"
        className="!h-11 !text-sm md:!w-auto md:shrink-0 md:whitespace-nowrap"
        onClick={onAdd}
      >
        {t("invoice.addDetails")}
      </Button>
    </div>
  );
}
